import { forward, guard, merge, sample } from "effector";

import {
  fetchOutcomeFx,
  fetchMoreOutcomeFx,
  OutcomeError$,
  data$,
  tableState$,
  fetchMore,
  refreshTable,
  TableGate,
} from "./index";
import { fetchOutcome } from "../../api";
import { logoutFx } from "../auth";

fetchOutcomeFx.use(fetchOutcome);
fetchMoreOutcomeFx.use(fetchOutcome);

data$.reset(logoutFx.finally);
OutcomeError$.reset(logoutFx.finally);

data$.on(fetchOutcomeFx.doneData, (state, source) => source);

sample({
  clock: merge([TableGate.open]),
  fn: () => ({
    page: 1,
  }),
  target: fetchOutcomeFx,
});
